import { UserSpeakerListAPIQueryParams, userSpeakerList, PaginatedSpeakerResponseList } from '@goldcast/api/content';

export function fetchSpeakers({
  queryParams,
  onErrorToast
}: {
  queryParams: UserSpeakerListAPIQueryParams;
  onErrorToast: (message: string) => void;
}) {
  return userSpeakerList({ queryParams })
    .then(speakers => {
      const processedSpeakers = ((speakers as unknown as PaginatedSpeakerResponseList['results']) || []).reduce(
        (acc, speaker) => {
          return { ...acc, [speaker.label as unknown as string]: speaker };
        },
        {}
      );
      return processedSpeakers;
    })
    .catch(() => {
      onErrorToast(
        'Uh-oh! We hit a snag loading the speakers. Quick check: is your internet feeling okay? If it looks good, give it another shot.'
      );
      return {};
    });
}
